module.exports = __webpack_public_path__ + "img/menu-filled.db11e7f3.svg";